import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import RecordPickerController from '../controllers/RecordPickerController';
import SelectroV2 from '@aha-app/selectro-v2';
import {
  type SearchableModelType,
  isSearchableType,
  SearchableModels,
} from 'components/framework/search_types';
import AhaAnalytics from 'javascripts/analytics';

const RecordTypeFilter: React.FC = () => {
  const controller = useController(RecordPickerController);
  const searchableTypes: SearchableModelType[] =
    controller.state.searchableTypes ||
    (Object.keys(SearchableModels) as SearchableModelType[]);

  const defaultOption = { value: '', text: 'All' };
  const itemList: { value: string; text: string }[] = [defaultOption];
  searchableTypes?.forEach(value => {
    itemList.push({
      value: value,
      text:
        (
          SearchableModels[value] as unknown as {
            terminologyName: string;
          }
        ).terminologyName || value,
    });
  });

  return (
    <SelectroV2
      className='!tw-w-[200px]'
      type='single'
      searchFields={['text']}
      items={itemList}
      text={{
        preScript: 'Record type: ',
      }}
      selected={defaultOption}
      callbacks={{
        select: ({ payload }) => {
          const selectedValue = payload.item.data.value;
          AhaAnalytics.track(
            'Feature-7517293737680706268',
            'User filters by record type',
            {
              'Record type': selectedValue,
            }
          );

          const searchableType = isSearchableType(selectedValue)
            ? selectedValue
            : undefined;

          controller.state.filteredRecordType = searchableType;
          void controller.actionPerformSearch(controller.state.search);
        },
      }}
    />
  );
};

export default ApplicationView(RecordTypeFilter);
